import React, { useState, useEffect, useCallback, Fragment } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import BackgroundUcl from '../../assets/Images/bg_ucl2.gif';
import NucleusLogo from '../../assets/Images/nUCLeus_logo.jpg';
import CircularProgress from "@mui/material/CircularProgress";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import { IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import { Link } from "react-router-dom";
import Copyright from "../../components/Copyrights/copyrights";
import { format } from "date-fns";
import { numberExp } from '../../utils/regularExpression';

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundImage: `url(${BackgroundUcl})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    height: '100%',

    //backgroundPosition: 'center',
  },
  image_logo: {
    backgroundImage: `url(${NucleusLogo})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    // backgroundColor:
    //   theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    // backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '100px',
    width: '230px'

  },
  paper: {
    margin: theme.spacing(2, 2),
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  instructions: {
    marginBottom: 10,
    textAlign: "center",
    fontSize: 12,
    padding: 1,
    color: "gray",
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: '80%'
  }
}));

const Login = (props) => {
  const classes = useStyles();

  const [form, setForm] = useState({
    studentId: "",
    dob: null,
  });
  const [formErrors, setFormErrors] = useState({
    studentId: "",
    dob: "",
  });
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successDialog, setSuccessDialog] = useState(false);

  const handleSuccessDialog = useCallback(() => {
    setSuccessDialog(prev => !prev);
  }, []);

  const resetForm = useCallback(() => {
    setForm({
      studentId: "",
      dob: null,
    });
    setFormErrors({
      studentId: "",
      dob: ""
    });
    setIsLoading(false);
  }, []);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    let regex = "";
    switch (name) {
      case "studentId":
        regex = new RegExp(numberExp);
        if (value && !regex.test(value)) {
          return;
        }
        break;
      default:
        break;
    }

    setForm(prev => ({ ...prev, [name]: value }));
    setFormErrors(prev => ({ ...prev, [name]: "" }));
  }, []);

  const handleDateChange = useCallback((date) => {
    setForm(prev => ({ ...prev, dob: date }));
    setFormErrors(prev => ({ ...prev, dob: "" }));
  }, []);

  const isFormValid = useCallback(() => {
    let isValid = true;
    const errors = { ...formErrors };

    if (!form.studentId) {
      errors.studentId = "Nucleus Id is Required";
      isValid = false;
    } else {
      errors.studentId = "";
    }
    if (!form.dob) {
      errors.dob = "Date of Birth is Required";
      isValid = false;
    } else {
      errors.dob = "";
    }

    setFormErrors(errors);

    return isValid;
  }, [form, formErrors]);

  const handleSubmitButtonClick = useCallback(() => {
    const isValid = isFormValid();
    if (isValid) {
      document.getElementById("submit-button").click();
    }
    return;
  }, [isFormValid]);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    setIsLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C100CommonStudentsSignup`;
    await fetch(url, { method: "POST", body: data })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (data) => {
          if (data.CODE === 1) {
            if (data.DATA) {
              if (data.DATA.length > 0) {
                setEmail(data.DATA[0].email);
              }
            }
            handleSuccessDialog();
            resetForm();
          } else {
            alert(data.USER_MESSAGE + " !\n" + data.SYSTEM_MESSAGE);
          }
        },
        (error) => {
          alert("Operation Failed !");
          console.log(error);
        }
      );

    setIsLoading(false);
  }, [handleSuccessDialog, resetForm]);

  const dob = form.dob ? format(form.dob, "dd/MM/yyyy") : new Date();

  return (
    <Fragment>
      <Dialog
        open={successDialog}
        onClose={handleSuccessDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Success"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Thank you for registering. Your online LMS account has been created successfully.
  You can now login to your account by entering the username and password sent to your email address <br />
            <b>{email}</b>.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSuccessDialog} color="primary">
            Close
          </Button>
          <Button onClick={() => window.location.replace("#/login")} color="primary" >
            Login
          </Button>
        </DialogActions>
      </Dialog>
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <Grid item xs={false} sm={12} md={12} className={classes.image} >
          <Grid container justifyContent="space-between" className={classes.root}>
            <Grid item xs={false} sm={5} md={6} justifyContent="space-between" elevation={6} square style={{ textAlign: 'center', marginLeft: '2%', marginTop: '12%' }}>

              <Typography variant="h2" style={{ textAlign: 'left', color: 'white', textShadow: '1px 1px 2px black' }} component="h2" gutterBottom>
                WELCOME TO NUCLEUS <br /> THE UNIVERSAL COLLEGE LAHORE PORTAL
                      </Typography>


            </Grid>
            <Grid item xs={12} sm={5} md={5}>
              <Grid item xs={12} sm={5} md={8} elevation={6} square style={{ alignContent: 'center', borderRadius: '18px', width: '95%', background: 'white', marginRight: '3%', marginTop: 85, marginBottom: '4%' }}>
                <div component={Paper} elevation={6} className={classes.container}>
                  <div className={classes.container}>

                    <div className={classes.paper}>
                      <div style={{ height: '50px' }} />
                      <Grid item className={classes.image_logo} />
                      <div style={{ height: '50px' }}>
                        <Typography variant="h4" style={{ textAlign: 'left' }} component="h2" gutterBottom>
                          SIGN UP
                        </Typography>
                      </div>
                      <form
                        noValidate
                        onSubmit={handleSubmit}
                        className={classes.form}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <TextField
                              variant="outlined"
                              required
                              fullWidth
                              id="studentId"
                              label="Nucleus Id"
                              name="studentId"
                              onChange={handleChange}
                              value={form.studentId}
                              error={!!formErrors.studentId}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <DatePicker
                              autoOk
                              invalidDateMessage=""
                              views={["year", "month", "date"]}
                              openTo={"year"}
                              disableFuture
                              variant="inline"
                              inputVariant="outlined"
                              label="Date of Birth"
                              format="dd-MMM-yyyy"
                              fullWidth
                              defaultValue={form.dob}
                              InputProps={{
                                endAdornment: (
                                  <IconButton size="large">
                                    <InsertInvitationIcon />
                                  </IconButton>
                                ),
                              }}
                              onChange={handleDateChange}
                              value={form.dob}
                              error={!!formErrors.dob}
                            />
                          </Grid>
                          <input name="dateOfBirth" type="hidden" value={dob} />
                          <input
                            id="submit-button"
                            type="submit"
                            style={{ display: "none" }}
                          />
                          <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            style={{ backgroundColor: `${isLoading ? "#6272ce" : ""}` }}
                            onClick={handleSubmitButtonClick}
                            disabled={isLoading}
                          >
                            {isLoading ? (
                              <CircularProgress style={{ color: "white" }} size={24} />
                            ) : (
                                "Sign Up"
                              )}
                          </Button>
                          <Grid container justifyContent="center">
                            <Grid item>
                              <Link to="/ucl/login" variant="body2">
                                {"Already have an account."}
                              </Link>
                            </Grid>
                          </Grid>
                        </Grid>
                      </form>
                    </div>
                    <div style={{ paddingBottom: 25 }}>
                      <Copyright />
                    </div>
                  </div>

                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
    </Grid>
    </Fragment>
  );
};

Login.propTypes = {};

export default Login;
